/* eslint-disable @typescript-eslint/no-unsafe-assignment */
// eslint-disable-next-line import/no-extraneous-dependencies
import React, { useState, useEffect } from 'react';
import { DateRangePicker as ReactDateRangePicker } from 'react-dates';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import './DateRangePicker.scss';
import moment from 'moment';
import { ChevronRight } from '../base/Svg/Icons';
// eslint-disable-next-line import/no-cycle
import { SvgIcons } from '../../index';

interface IDateRangePickerTemplate {
  currentDateRange: { startDate: moment.Moment; endDate: moment.Moment };
  onchanged: (startDate: moment.Moment, endDate: moment.Moment) => void;
  onFocus?: (start: boolean) => void;
  onBlur?: () => void;
  showIcon?: boolean;
  startDatePlaceholder?: string;
  endDatePlaceholder?: string;
  // maxDays?: number;
}

const DateRangePicker: React.FC<IDateRangePickerTemplate> = ({ currentDateRange, onchanged, onFocus, onBlur, showIcon = false, startDatePlaceholder, endDatePlaceholder /* , maxDays */ }) => {
  moment.locale(window.twindow.langCode);

  const [calendarFocused, setCalendarFocused] = useState<'startDate' | 'endDate' | null>(null);
  const [dateRange, setDateRange] = useState<{ startDate: moment.Moment | null; endDate: moment.Moment | null }>(currentDateRange);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.matchMedia('(max-width: 768px)').matches);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const handleDateChange = ({ startDate, endDate }: { startDate: moment.Moment | null; endDate: moment.Moment | null }) => {
    if (startDate && dateRange.startDate && startDate < dateRange.startDate) {
      setDateRange({ startDate, endDate: null });
    } else if (startDate) {
      setDateRange({ startDate, endDate });
    }

    if (dateRange.endDate && endDate) {
      setCalendarFocused('startDate');
    }

    if (startDate && endDate) {
      onchanged(startDate, endDate);
      if (isMobile) {
        setTimeout(() => {
          setCalendarFocused(null);
        }, 300);
      }
    }
  };

  const handleFocusChange = (focused: 'startDate' | 'endDate' | null) => {
    setCalendarFocused(focused);
    if (focused) {
      if (onFocus) onFocus(focused === 'startDate');
      return;
    }
    if (onBlur) onBlur();
  };

  const isOutsideRange = (day: moment.Moment) => {
    if (calendarFocused === 'endDate') {
      const endDateIsBeforeNow: boolean = day.isBefore(moment());
      if (endDateIsBeforeNow) return true;

      const startDateAddMaxDay = moment(dateRange.startDate, 'DD.MM.YYYY').add('days', 13);
      const endDateIsAfterMaxDay: boolean = day.isAfter(startDateAddMaxDay);
      if (endDateIsAfterMaxDay) return true;
    }

    const startDateIsBeforeNow: boolean = day.isBefore(moment());
    if (startDateIsBeforeNow) return true;

    return false;
  };

  return (
    <div className="date-range-picker-container" style={{ position: 'relative' }}>
      {/* 👇 İkon eklendi */}
      {showIcon && (
        <div
          style={{
            position: 'absolute',
            left: '14px',
            top: '50%',
            transform: 'translateY(-50%)',
            pointerEvents: 'none',
            color: '#999',
            zIndex: 2,
          }}
        >
          <SvgIcons.Calendar className="w-5 h-5" />
        </div>
      )}
      <ReactDateRangePicker
        startDate={dateRange.startDate}
        startDateId="startDate"
        endDate={dateRange.endDate}
        endDateId="endDate"
        onDatesChange={({ startDate, endDate }) => handleDateChange({ startDate, endDate })}
        displayFormat="MMM Do YYYY"
        block
        customArrowIcon={showIcon ? <span style={{ color: '#ccc', fontWeight: 500 }}>|</span> : <ChevronRight />}
        minimumNights={0}
        focusedInput={calendarFocused}
        onFocusChange={handleFocusChange}
        hideKeyboardShortcutsPanel
        isOutsideRange={isOutsideRange}
        orientation={isMobile ? 'vertical' : 'horizontal'}
        withPortal={isMobile}
        startDatePlaceholderText={startDatePlaceholder || undefined}
        endDatePlaceholderText={endDatePlaceholder || undefined}
        onClose={({ startDate, endDate }) => {
          if (startDate && !endDate) {
            const newDateRange = { ...dateRange };
            newDateRange.startDate = startDate;
            newDateRange.endDate = moment(dateRange.startDate, 'DD.MM.YYYY').add(3, 'days');
            setDateRange(newDateRange);
            onchanged(newDateRange.startDate, newDateRange.endDate);
          } else if (!startDate && !endDate) {
            setDateRange(currentDateRange);
            onchanged(currentDateRange.startDate, currentDateRange.endDate);
          }
        }}
      />
    </div>
  );
};

export default DateRangePicker;
